module.exports = __webpack_public_path__ + "img/Mockups 2.8750212a.png";